<template>
  <main id="symbolPage" :dir="uiDirection" :class="{ preview: isPreview }">

    <div id="pageTabs" v-if="equityPrice">
      <div id="miniEquity" @click="tabClick('overview')">
        <div id="miniLogo">
          <img :src="logo" ref="logo" v-if="!hideLogo" />
        </div>
        {{ symbol }}
      </div>

      <div class="tabs round scroll noBorder noMargin small transparent" :theme="systemTheme">
        <div class="tab" @click="tabClick('overview')" :class="{ active: activeTab === 'overview' }">
          <i class="ri-folder-open-line" />
          {{ dictionary.symbolPage.tabs.overview }}
        </div>

        <div class="tab" @click="tabClick('chart')" v-if="!isPreview" :class="{ active: activeTab === 'chart' }">
          <i class="ri-line-chart-line" />
          {{ dictionary.symbolPage.tabs.chart }}
        </div>

        <div class="tab" @click="tabClick('news'); feedKey++;" :class="{ active: activeTab === 'news' }">
          <i class="ri-newspaper-line" />
          {{ dictionary.symbolPage.tabs.news }}
        </div>
        <div class="tab" @click="tabClick('performance')" :class="{ active: activeTab === 'performance' }">
          <i class="ri-bar-chart-2-line" />
          {{ dictionary.symbolPage.tabs.performance }}
        </div>
        <div class="tab" @click="tabClick('financials')" v-if="!isPreview"
          :class="{ active: activeTab === 'financials' }">
          <i class="ri-file-list-2-line" />
          {{ dictionary.symbolPage.tabs.financials }}
        </div>
        <div class="tab" @click="tabClick('insiders')" v-if="!isPreview" :class="{ active: activeTab === 'insiders' }">
          <i class="ri-briefcase-4-line" />
          {{ dictionary.symbolPage.tabs.insiders }}
        </div>
      </div>
    </div>

    <OverviewPartial v-if="activeTab === 'overview'" @scrolledUp="showMiniEquity = false"
      @scrolledDown="showMiniEquity = true" :symbol="symbol" :is-preview="isPreview"
      :isDev="this.$route.name === 'DevSymbol'" :peers="peers" :watchlist="watchlist" :equityPrice="equityPrice"
      :symbolInfo="symbolInfo" />

    <div v-if="activeTab === 'chart'" ref="chartContainer" style="height: 500px">
      <TradingViewChart :theme="systemTheme === 'darkMode' ? 'dark' : 'light'" :symbol="symbol" />
    </div>
    <!--    <ChartPartial v-if="activeTab === 'chart'" :equityPrice="equityPrice"-->
    <!--                  :symbolInfo="symbolInfo"-->
    <!--                  :symbol="symbol"/>-->

    <PerformancePartial v-if="activeTab === 'performance'" :equityPrice="equityPrice" :symbol="symbol" />

    <FinancialsPartial v-if="activeTab === 'financials'" :equityPrice="equityPrice" :symbol="symbol" />

    <InsidersPartial v-if="activeTab === 'insiders'" :symbol="symbol" />

    <Feed :type="'symbolPage'" v-if="activeTab === 'news'" ref="symbolFeed" :key="`symbolFeed${feedKey}`"
      :has-tabs="true" :aggregate="false" :hideEventsBySymbols="[symbol]" :showFilters="true" :prices="prices.prices"
      @feedLoaded="() => { }" :symbols="[symbol]" />
  </main>

</template>

<script>

import SymbolPagePriceBlock from "../components/symbols/symbolPagePriceBlock";
import eventBus from "../services/events";

import { useWatchlist } from "../stores/watchlist";
import { useEquityPrices } from "../stores/equityPrices";
import Feed from "./FeedView";

import BigLoader from "../components/ui/BigLoader";
import InsidersPartial from "./symbolView/InsidersPartial";
import PerformancePartial from "./symbolView/PerformancePartial";
import FinancialsPartial from "./symbolView/FinancialsPartial";
import SymbolLabel from "../components/symbols/symbol";
import OverviewPartial from "./symbolView/OverviewPartial.vue";
import SymbolService from "../services/symbols";
import TradingViewChart from "../components/charts/TradingView";

export default {
  name: "SymbolView",
  components: {
    TradingViewChart,
    OverviewPartial,
    SymbolLabel,
    FinancialsPartial,
    PerformancePartial,
    InsidersPartial,
    BigLoader,
    Feed,
    SymbolPagePriceBlock
  },
  props: ['prices', 'isPreview', 'previewSymbol'],
  data() {
    return {
      feedKey: 0,
      activeTab: 'overview',
      companyEarningsChart: null,
      divToolTipOn: false,
      symbolInfo: null,
      showMiniEquity: false,
      logo: null,
      hideLogo: null,
      observer: null,
      news: [],
      peers: [],
      watchlist: useWatchlist(),
      symbol: this.previewSymbol ? this.previewSymbol : this.$route.params.symbol
    }
  },
  computed: {
    equityPrice() {

      return this.equityPrices.prices[this.symbol] || this.symbolInfo;
    }
  },
  methods: {
    handleResize() {
      this.calcChartHeight();

    },
    tabClick(tab) {

      this.showMiniEquity = tab !== 'overview';
      this.activeTab = tab;


      this.$nextTick(() => {

        this.calcChartHeight();

      });
    },
    async getSymbolPeers() {
      this.peers = this.$route.name === 'DevSymbol' ? await SymbolService.getSymbolPeersDev(this.symbol) : await SymbolService.getSymbolPeers(this.symbol);
    },
    setLogo() {
      let loadImage = new Image();
      loadImage.crossOrigin = 'anonymous'
      loadImage.style.width = '100%';

      loadImage.onload = () => {
        this.logo = `https://financialmodelingprep.com/image-stock/${this.symbol}.png`
        setTimeout(() => {
        }, 1);
      };

      loadImage.onerror = () => {
        this.hideLogo = true;
      }

      loadImage.src = `https://financialmodelingprep.com/image-stock/${this.symbol}.png`;
    },
    calcChartHeight() {

      const viewElement = document.getElementById('macroNewsFeed');
      const pageTabs = document.getElementById('pageTabs');
      const height = viewElement.offsetHeight - pageTabs.offsetHeight;
      if (this.$refs && this.$refs.chartContainer) {
        this.$refs.chartContainer.style.height = `${height - 15}px`;
      }

    },
    loadNext() {

      if (this.$refs.symbolFeed) {
        this.$refs.symbolFeed.loadNext();
      }
    },
  },
  created() {

    setTimeout(() => {
      this.$nextTick(() => {


        this.$.appContext.config.socket.joinSocketRooms([this.symbol]);

        setTimeout(() => {
          if (!this.equityPrice) {
            this.$.appContext.config.socket.joinSocketRooms([this.symbol]);
          }
        }, 2000)
      })
    }, 1);
  },
  setup() {

    const equityPrices = useEquityPrices();
    equityPrices.$subscribe(() => {
    });
    return { equityPrices };
  },
  async mounted() {

    window.addEventListener('resize', this.handleResize);

    this.$nextTick(async () => {

      this.setLogo();
      const infoRequest = await Promise.all([this.getSymbolPeers(), SymbolService.getSymbolInfo(this.symbol)]);
      this.symbolInfo = infoRequest[1];
      this.isLoading = false;


      const { tab } = this.$route.query;
      if (tab) this.activeTab = tab;

      eventBus.on('mainViewScrolledToBottom', this.loadNext);
    })

  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    eventBus.off('mainViewScrolledToBottom', this.loadNext);
  },
}
</script>

<style scoped lang="scss">
@import "../assets/style/vars";
@import "../assets/style/notification";
@import "../assets/style/controls";

.preview {
  background: var(--bgColor);
}

.tabs {
  margin: 0 !important;

  &[theme="lightMode"] {
    .tab.active {
      color: var(--bgColor);
    }
  }
}

#pageTabs {
  width: 100%;
  display: flex;
  align-items: center;
  position: sticky;
  top: -1px;
  z-index: 10;
  border-bottom: 2px solid var(--highlightColor);
  background: var(--bgColor);


  #miniEquity {

    #miniLogo {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: relative;
      background: #1d1d1d;
      overflow: hidden;
      white-space: nowrap;

      img {
        position: absolute;
        left: 6px;
        top: 6px;
        width: 18px;
      }
    }

    white-space: nowrap;
    overflow: hidden;
    transition: $transition;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    padding: $smallGap;
  }
}
</style>
